/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecordActionEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}